<template> 
	<table border="0" cellspacing="0" cellpadding="0" class="zsldt_pagetable1" width="100%">
		<tr>
			<th colspan="3">{{ldtNotion?ldtNotion+'-':""}}总体评分</th>
			<th colspan="4">{{ldtname[0].value.toFixed(2)}}</th> 
		</tr> 
		<tr>
			<td colspan="2">分析要素</td>
			<td>说明</td> 
			<td>得分</td>
			<td>级别</td>
			<td>得分说明</td>
		</tr>
		<tr >
			<td rowspan="2">企业</td>
			<td>{{ldtname[1].text}}</td>
			<td class="font-kt"> 有实力投</td> 
			<td>{{ldtname[1].value}}</td>
			<td>  {{ldtname[1].level}}</td>
			<td  class="text_al font-kt">{{ldtname[1].summary}}</td>
		</tr>
		<tr> 
			<td>{{ldtname[2].text}}</td>
			<td class="font-kt"> 实际在投</td> 
			<td>{{ldtname[2].value}}</td>
			<td>{{ldtname[2].level}}</td>
			<td class="text_al font-kt">{{ldtname[2].summary}}</td>
		</tr>
		<tr>
			<td rowspan="2">行业</td>
			<td>{{ldtname[3].text}}</td>
			<td class="font-kt"> 有机会投</td> 
			<td>{{ldtname[3].value}}</td>
			<td>{{ldtname[3].level}}</td>
			<td  class="text_al font-kt">{{ldtname[3].summary}}</td>
		</tr>
		<tr> 
			<td>{{ldtname[4].text}}</td>
			<td class="font-kt"> 被鼓励投</td> 
			<td>{{ldtname[4].value}}</td>
			<td>{{ldtname[4].level}}</td>
			<td class="text_al font-kt">{{ldtname[4].summary}}</td>
		</tr> 
	</table>  
</template>

<script>
	export default {
		name: 'investDynamic',
		data: function(){
			return{ 
				ldtname:[{value:100},{value:100},{value:100},{value:100},{value:100}],
			}},
			props:{
				listData:{type:Array },
				ldtNotion:{type:String}
			},
			// watch:{
			// 	listData: {
			// 		handler(newValue, oldValue) {
			// 			this.listData = newValue;
			// 			this.ldtname=this.swapArr(this.listData,4,5) 
			// 		}
			// 	},
			// },
			mounted() {  
				this.ldtname=this.swapArr(this.listData,4,5) 
			},
			methods:{
				swapArr(arr1, index1, index2) { //调换数组元素位置
				var arr=arr1;
				arr[index1] = arr.splice(index2, 1, arr[index1])[0];
				return arr
				},
				getranderdata(type,code){
					var _this=this;   
					this.zsldnav=code
					if(type==0){
						var ajaxurl = this.$api.cyl.GovInvestAlg.detail()+"?stockCode="+this.enterpriseid; 
					}else{
					var ajaxurl =	this.$api.cyl.GovInvestAlg.detail()+"?stockCode="+this.enterpriseid+"&notionCode="+_this.zsldnav;
					}
					this.$axios.get(ajaxurl,{headers:{AuthToken:this.userdata.token}}).then(function(res){
						// console.log("雷达图数据",res.data,ajaxurl);
						_this.issucss = res.data.success;
						if(res.data.success){ 
							if(type==0){
								_this.zsldnav = res.data.data.notionList[0].code;
							}
							_this.randerdata2 = res.data.data;
							_this.randerdata = res.data.data.provinceRelated ;
							_this.randerpagedata = res.data.data;
							_this.ldtname=res.data.list; 
							_this.ldtname = _this.swapArr(_this.ldtname,4,5)
							_this.ldtname[0].text='总体评分'; 
							
						var newdata=res.data.list.filter((list)=>{
							return list.text!='本省关联度' && list.text!='总体评分';
						});
							
						// _this.convert(res.data.data.project);
						setTimeout(()=>{
						  _this.holdradarFun('enterprise_zsldtchart',newdata);  //不知道为啥$nextTick没用就用了定时器，不用的话图不能实时获取盒子高度
						},500) 
						} 
					}).catch(function (error) { 
						// 请求失败处理 console.log(error);
					});  
				},
			},
			
	}
	
</script>

<style>
</style>